import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule, SETTINGS } from '@angular/fire/compat/firestore';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { AngularFireStorageModule, BUCKET } from '@angular/fire/compat/storage';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxCurrencyConfig, NgxCurrencyInputMode, provideEnvironmentNgxCurrency } from 'ngx-currency';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiHelperService } from './core/api-helper.service';
import { AuthService } from './core/auth.service';
import { FormHelperService } from './core/form-helper.service';
import { AdminLayoutComponent } from './core/layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './core/layouts/auth/auth-layout.component';
import { Messaging } from './core/messaging.service';
import { StateService } from './core/state.service';
import { SharedModule } from './shared/shared.module';

import { LandingComponent } from './pages/landing/landing.component';


const maskConfigFunction: () => Partial<NgxMaskConfig> = () => {
    return {
        validation: false,
    };
};

export const customCurrencyMaskConfig: Partial<NgxCurrencyConfig> = {
    align: 'right',
    allowNegative: true,
    allowZero: false,
    decimal: '.',
    nullable: true,
    precision: 2,
    suffix: '',
    thousands: ',',
    prefix: '',
    inputMode: NgxCurrencyInputMode.Financial
};

@NgModule({ declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        LandingComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFireStorageModule,
        AngularFirestoreModule,
        AngularFireFunctionsModule,
        FlexLayoutModule,
        NgxExtendedPdfViewerModule,
        FontAwesomeModule], providers: [
        Messaging,
        ApiHelperService,
        AuthService,
        StateService,
        provideEnvironmentNgxMask(maskConfigFunction),
        provideEnvironmentNgxCurrency(customCurrencyMaskConfig),
        FormHelperService,
        {
            provide: BUCKET,
            useValue: environment.firebase.storageBucket
        },
        {
            provide: SETTINGS,
            useValue: environment.envName !== 'dev' ? undefined : {
                host: 'localhost:8080',
                ssl: false
            }
        },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true }
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
